import React, { useEffect, useState } from "react";
import { ReportAPI } from "@ai360/core";

import {
    ReportTable,
    ReportOptionsContainer,
    ReportTypes,
    CategoryTree,
    yieldByDataSet,
} from "./components";
import { withReport } from "./hocs";

import { DialogBox, DialogBoxFooterType, Loader } from "~/core";
import { IWithReportProps } from "~/reports/hocs/with-report";
import { categoryTypes } from "~/reports/data";
import { messages } from "./i18n-messages";

import "./reports.css";
import { IRecordObject } from "~/core/components/tree-view/tree-view";
import { defaultYieldByCategory, IYieldByCategory } from "~/reports/data/model";
import { useIntl } from "react-intl";

const service = {
    REPORT_TYPE_LIST_URL: ReportAPI.GET_REPORT_TYPE_LIST_URL,
    REPORT_TYPE_PAGE_LIST_URL: ReportAPI.GET_REPORT_TYPE_PAGE_LIST_URL,
};
interface IProps extends IWithReportProps {
    createReportHubProgress?: boolean;
    initialRequestOptions?: Record<string, any>;
    onAllReportCreated?: () => void;
    selectedReportTypeNames?: string[];
    selectedReportTypes?: string[];
    selectReportType?: () => void;
}

const AllReports_ = (props: IProps) => {
    const { formatMessage } = useIntl();

    const [isLoading, setLoading] = useState(false);
    const [activeModal, setActiveModal] = useState<number | null>(null);
    const [categories, setCategories] = useState<IYieldByCategory>(
        props.yieldByCompareByOptions ?? defaultYieldByCategory()
    );
    const [dataSet, setDataSet] = useState(yieldByDataSet(formatMessage));

    useEffect(() => {
        if (props.reportPreferences?.labSubmissionTestingLabVendorGuid) {
            getTestPackageListData(props.reportPreferences.labSubmissionTestingLabVendorGuid);
        }
    }, [props.reportPreferences?.labSubmissionTestingLabVendorGuid]);

    useEffect(() => {
        setCategories(props.yieldByCompareByOptions);
    }, [props.yieldByCompareByOptions]);

    const getTestPackageListData = (vendorGuid) =>
        props.needs([props.getTestPackageListData(vendorGuid)]);

    const onClickCategories = (type: number) => {
        if (type === categoryTypes.yieldBy) {
            setLoading(true);
            setCategories(props.yieldByCompareByOptions);
            setDataSet(yieldByDataSet(formatMessage));
            setActiveModal(categoryTypes.yieldBy);
            setLoading(false);
        }
    };

    const onModalSave = () => {
        if (activeModal === categoryTypes.yieldBy) {
            setLoading(true);
            const newCategory = {
                ...categories,
                template: [],
                managementAreaOptions: "",
            };
            setCategories(newCategory);
            props.needs([props.updateYieldByCompareByOptions(newCategory)]);
            setActiveModal(null);
            setLoading(false);
        }
    };

    return (
        <div className="reports-container">
            <div className="reports-options-container">
                <ReportTypes
                    withRecentUsed={true}
                    selectReportType={props.selectReportType}
                    reportTypes={props.reportTypes}
                    selectedReportTypes={props.selectedReportTypes}
                />
                <ReportOptionsContainer
                    createReport={props.createReport}
                    fileNameFormats={props.fileNameFormats}
                    reportPreferences={props.reportPreferences}
                    reportTypePages={props.reportTypePages}
                    selectedReportTypes={props.selectedReportTypeNames}
                    onClickCategories={onClickCategories}
                    getTestPackageListData={getTestPackageListData}
                />
            </div>
            <ReportTable
                createReportHubProgress={props.createReportHubProgress}
                initialRequestOptions={props.initialRequestOptions}
                needs={props.needs}
                onAllReportCreated={props.onAllReportCreated}
                url={ReportAPI.GET_REPORT_LIST_URL}
                autoSearchUrl={ReportAPI.GET_REPORT_AUTO_SEARCH_URL}
                selectAllUrl={ReportAPI.GET_REPORT_SELECT_ALL_URL}
            />
            <DialogBox
                unrestricted
                title={formatMessage(messages.yieldByCompareByOptions)}
                isOpen={activeModal !== null}
                onAction={onModalSave}
                onClose={() => setActiveModal(null)}
                footerType={DialogBoxFooterType.ACTION_CANCEL}
                testId="all-reports-yield-by-compare-by-modal"
            >
                {isLoading ? <Loader className="field-report-loader" /> : null}
                <CategoryTree
                    onStatusChange={(value) => setCategories(value as IYieldByCategory)}
                    formatMessage={formatMessage}
                    categories={categories}
                    categoryDataSet={dataSet as IRecordObject[]}
                />
            </DialogBox>
        </div>
    );
};

export const AllReports = withReport(AllReports_, service);
